/**
 * Generated runtime TestId mirror for frontend/src/pages/reporting/ParameterEditor.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ParameterEditorTestIds = {
  btnAddParameter: "btn-add-parameter",
  paramDefNewName: "param-def-new-name",
  parameterDefinitionEditor: "parameter-definition-editor",
  paramDef: (definition_name: string) => `param-def-${definition_name}`,
  paramDefPrefix: () => "param-def-" as TestIdPrefix,
  paramDefRemove: (definition_name: string) => `param-def-remove-${definition_name}`,
  paramDefRemovePrefix: () => "param-def-remove-" as TestIdPrefix
} as const;
